import React, { Component } from "react";
import actions from "actions";
import constants from "constants";
import { connect } from "react-redux";
import InputField from "components/InputField/InputField";
import { userLeaveGroup } from "../../../actions/studygroups";

const { hideModal } = actions;

class UserLeaveGroupModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      query: "",
      step: 1,
    };
  }

  handleQueryChange = (query) => this.setState({ query });

  handleLeave = () => {
    this.props.userLeaveGroup();
    this.props.hideModal();
  };

  lastStep = () => {
    const { query } = this.state;

    const isCorrect = query === "CONFIRM";

    return (
      <div className="action-confirmation">
        <h5 className="title">
          Please confirm that you wish to leave the group
        </h5>
        <div style={{ width: 400, margin: "auto", marginBottom: "16px" }}>
          <InputField
            label={"Please type in CONFIRM to leave this group"}
            onChange={(e) => this.handleQueryChange(e.target.value)}
            value={this.state.query}
          />
        </div>
        <div className="actions">
          <button
            className="delete-action"
            disabled={!isCorrect}
            onClick={this.handleLeave}
          >
            Leave MedMeeting
          </button>
          <button className="cancel-action" onClick={this.props.hideModal}>
            Exit to MedMeeting
          </button>
        </div>
      </div>
    );
  };

  secondStep = () => {
    return (
      <div className="action-confirmation">
        <h5 className="title">
          You will no longer be able to access your CPD Certificates from this
          group if you leave. Please download a copy of your certificates before
          you proceed
        </h5>
        <div className="actions">
          <button className="delete-action" onClick={this.handleNextStep}>
            Proceed to leave MedMeeting
          </button>
          <button className="cancel-action" onClick={this.props.hideModal}>
            Exit to MedMeeting
          </button>
        </div>
      </div>
    );
  };

  handleNextStep = () => this.setState({ step: this.state.step + 1 });

  firstStep = () => {
    return (
      <div className="action-confirmation">
        <h5 className="title">Are you sure you want to leave this group?</h5>
        <div className="actions">
          <button className="delete-action" onClick={this.handleNextStep}>
            Yes
          </button>
          <button className="cancel-action" onClick={this.props.hideModal}>
            Cancel
          </button>
        </div>
      </div>
    );
  };

  render() {
    const { step } = this.state;

    return (
      <div>
        {step === 1 && this.firstStep()}
        {step === 2 && this.secondStep()}
        {step === 3 && this.lastStep()}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    contentProps: state.modal.modalContentProps,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    hideModal: () => dispatch(hideModal()),
    userLeaveGroup: () => dispatch(userLeaveGroup()),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserLeaveGroupModal);



// WEBPACK FOOTER //
// ./src/containers/Admin/UserLeaveGroupModal/index.jsx